import { Col, Row } from 'antd';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useThemeComponents } from '../../../../themes';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import { type ApplicantFormValues, Container, Title } from './shared';

const colSpan = { md: 12, sm: 24, xs: 24 };

const CustomizedFieldsSection = () => {
    const { t } = useTranslation('eventApplicantForm');
    const translate = useTranslatedString();

    const { values } = useFormikContext<ApplicantFormValues>();

    const {
        FormFields: { InputField },
    } = useThemeComponents();

    return (
        <Container>
            <Title>{t('eventApplicantForm:additionalInformation.title')}</Title>
            <Row gutter={[24, 12]}>
                {values.customizedFields.map((customField, index) => (
                    <Col key={`customizedField_${index.toString()}`} {...colSpan}>
                        <InputField
                            label={translate(customField.displayName)}
                            maxLength={customField.characterLimit}
                            name={`customizedFields.${index}.value`}
                            required={customField.isMandatory}
                        />
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default CustomizedFieldsSection;
